// extracted by mini-css-extract-plugin
export var container = "style-module--container--c79cd";
export var external = "style-module--external--a553c";
export var logo = "style-module--logo--baa39";